export const getGarmentCustomiser = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/garmentCustomiser/getters.js